export default httpClient => ({
  save: async ({ clinica, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/clinicas', clinica, { headers });
    return {
      data: response.data,
    }
  },
  update: async ({ clinica, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.put('/clinicas/' + clinica.id, clinica, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/clinicas', { headers });
    return { data: response.data }
  },
  getDestaque: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/clinicas-destaque', { headers });
    return { data: response.data }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/clinicas/' + id, { headers });
    return {
      data: response.data
    }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/clinicas/' + id, { headers });
    return {
      data: response
    }

  },
  deletarImagem: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
    return {
      data: response
    }
  },
  savePlano: async ({ planos, clinica_id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/planos-clinicas', { planos, clinica_id }, { headers })
    return {
      data: response.data,
    }
  },

  getClinicaDestaque: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/profissionais-destaque', { headers });
    return { data: response.data }
  },
  //salvar profissional clinica
  saveProfissionais: async ({ clinica_id, profissionais, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/profissionais-clinicas', { clinica_id, profissionais }, { headers });
    return {
      data: response.data,
    }
  },
  updateProfissionais: async ({ profissional_id, nome, especialidade_id, descricao, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.put('/profissionais-clinicas/' + profissional_id, { nome, especialidade_id, descricao, }, { headers });
    return {
      data: response.data,
    }
  },
  deleteProf: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/profissionais-clinicas/' + id, { headers });
    return {
      data: response
    }
  },

  //salvar rede-social clinica
  saveRedeSocial: async ({ clinica_id, nome, valor, link, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/redes-sociais', { clinica_id, nome, valor, link }, { headers });
    return {
      data: response.data,
    }
  },
  updateSocial: async ({ social_id, nome, valor, link, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.put('/redes-sociais/' + social_id, { nome, valor, link, }, { headers });
    return {
      data: response.data,
    }
  },
  deleteSocial: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/redes-sociais/' + id, { headers });
    return {
      data: response
    }
  },

  //depoimento
  getDepoimento: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/depoimentos-por-clinica/' + id, { headers });
    return {
      data: response.data
    }
  },
  getDepoimentoById: async ({ id_depoimento, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/depoimentos/' + id_depoimento, { headers });
    return {
      data: response.data
    }
  },
  deleteDepoimento: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/depoimentos/' + id, { headers });
    return {
      data: response.data
    }
  },
  aprovarDepoimento: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/aprovar-depoimento/' + id, { headers });
    return {
      data: response.data
    }
  },
  getDepoimentoPendentes: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/depoimentos-pendentes', { headers });
    return {
      data: response.data
    }
  },
});